import { Sex } from '@/customer/models/Customer';

export interface CustomerQueryKeyword {
  fields: string[];
  key: string;
}

export interface CustomerQuerySubscribeTime {
  notIn: boolean;
  start: string;
  end: string;
}

export interface CustomerQueryLocationCond {
  country?: string;
  province?: string;
  city?: string;
}

export interface CustomerQueryLocation {
  notIn: boolean;
  conds: CustomerQueryLocationCond[];
}

export interface CustomerQueryInteractive {
  interactiveType?: number[];
  range: any;
}

export interface CustomerTopicQuery {
  topics: number[];
  notIn: boolean;
}

export interface Days {
  day?: number;
}

export interface CustomerQueryTrace {
  min?: number;
  max?: number;
}

export interface CustomerQueryScore {
  min?: number;
  max?: number;
}

export interface CustomerQueryGroup {
  mode: string;
  ids: number[];
}

export interface CustomerQueryRemark {
  mode: string;
  ids: number[];
  groupIds?: number[];
}

export interface CustomerQueryMemberCard {
  notIn: boolean;
  cardId: number[];
}

export interface CustomerQuerySubscribeScene {
  notIn: boolean;
  scenes: string[];
}

export interface CustomerQuery {
  pageSize: number;
  page: number;
  sort: string;
  topicQuery?: CustomerTopicQuery;
  keyword?: CustomerQueryKeyword;
  sex?: Sex;
  subscribeTime?: CustomerQuerySubscribeTime;
  location?: CustomerQueryLocation;
  interactive?: CustomerQueryInteractive;
  remark?: CustomerQueryRemark;
  trace?: CustomerQueryTrace;
  score?: CustomerQueryScore;
  scoreSum?: CustomerQueryScore;
  group?: CustomerQueryGroup;
  memberCard?: CustomerQueryMemberCard;
  subscribeScene?: CustomerQuerySubscribeScene;
  prop?: CustomerQueryProp;
  topics?: number[];
  subscribe?: boolean;
}

export interface CustomerQueryProp {
  conds: CustomerQueryPropItem<any>[];
}

export interface CustomerQueryPropItem<T> {
  In?: CustomerQueryPropIn<T>;
  Lt?: CustomerQueryPropUnary<T>;
  Gt?: CustomerQueryPropUnary<T>;
  Le?: CustomerQueryPropUnary<T>;
  Eq?: CustomerQueryPropUnary<T>;
  Ge?: CustomerQueryPropUnary<T>;
  Range?: CustomerQueryRange<T>;
}

export interface CustomerQueryPropIn<T> {
  field: string;
  values: T[];
  notIn: boolean;
}

export interface CustomerQueryPropUnary<T> {
  field: string;
  value: T;
}

export interface CustomerQueryRange<T> {
  field: string;
  maxInclude: boolean;
  min: T;
  max: T;
  minInclude: boolean;
  notIn: boolean;
}

const customerQuery: CustomerQuery = {
  pageSize: 30,
  page: 1,
  sort: 'wxProps.subscribeTime desc',
  subscribe: true,
};

export default customerQuery;
